import styled, { keyframes } from 'styled-components';

import selectDropdownSvg from 'assets/icons/select-dropdown.svg';
import uncheckedIconSvg from 'assets/icons/unchecked-icon.svg';
import checkedIconSvg from 'assets/icons/checked-icon.svg';
import partialCheckedIconSvg from 'assets/icons/partial-checked-icon.svg';
import { medias } from 'assets/styled/tokens/medias';

export const DropdownWrapper = styled.div<{ isOpened?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 99;

  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 0;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const DropdownChildren = styled.div<{ isOpened?: boolean }>`
  background: #fff;
  padding: 12px;
  position: relative;
  z-index: 11;
  flex: 1;
  text-align: center;

  &::after {
    content: '';
    display: inline-block;
    background: url(${selectDropdownSvg}) no-repeat center/contain;
    display: inline-block;
    height: 8px;
    width: 8px;
    margin-left: 6px;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const DropdownContent = styled.div<{ isOpened?: boolean }>`
  background: #fff;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  display: ${({ isOpened = false }) => (isOpened ? 'block' : 'none')};
  left: 0;
  min-width: 170px;
  position: absolute;
  z-index: 9999;
  top: 100%;

  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    z-index: 9999 !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    animation: ${({ isOpened = false }) => (isOpened ? slideUp : 'none')} 0.5s ease;
  }
`;

export const DropdownContentInner = styled.div`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.25);
  color: #888;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 2px;
`;

export const DropdownMenu = styled.div`
  @media screen and (max-width: ${medias.tablet}) {
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 5px;
  }
`;

export const DropdownMenuItem = styled.div<{ isSelected?: boolean }>`
  padding: 6px 8px;

  @media screen and (max-width: ${medias.tablet}) {
    font-size: 16px;
    padding: 8px;
  }

  &:hover {
    background-color: #f5f3f1;
  }
`;

export const DropdownMenuIconCheck = styled.span<{
  isSelected?: boolean;
  isPartialSelected?: boolean;
}>`
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 8px;
  background: ${({ isSelected = false, isPartialSelected = false }) =>
      isSelected
        ? `url(${checkedIconSvg})`
        : isPartialSelected
        ? `url(${partialCheckedIconSvg})`
        : `url(${uncheckedIconSvg})`}
    no-repeat center/contain;

  @media screen and (max-width: ${medias.tablet}) {
    width: 20px;
    height: 20px;
  }
`;
